"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _UIRouterTab = _interopRequireDefault(require("ui-addon-react-router/UIRouterTab"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _selectors = require("settings-ui-sdk/Routes/selectors");

var _constants = require("../constants");

var translateLangKey = function translateLangKey(key) {
  return _react.default.createElement(_FormattedMessage.default, {
    message: "marketing.domains.tabs." + key
  });
};

var TAB_IDS = [_constants.LANGUAGE_SETTINGS_ROUTE, _constants.SITEMAPS_ROUTE];

var TabsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TabsContainer, _PureComponent);

  function TabsContainer() {
    (0, _classCallCheck2.default)(this, TabsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TabsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(TabsContainer, [{
    key: "getActiveTab",
    value: function getActiveTab() {
      var _this$props = this.props,
          lastURLPathElement = _this$props.lastURLPathElement,
          pathNameFromRouting = _this$props.pathNameFromRouting;

      if (pathNameFromRouting.includes(_constants.SITEMAPS_ROUTE)) {
        return _constants.SITEMAPS_ROUTE;
      }

      return lastURLPathElement;
    }
  }, {
    key: "renderTab",
    value: function renderTab(id) {
      return _react.default.createElement(_UIRouterTab.default, {
        key: id,
        tabId: id,
        title: translateLangKey(id),
        to: _constants.BASE_DOMAINS_TAB_ROUTE + "/" + id
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UITabs.default, {
        defaultSelected: _constants.LANGUAGE_SETTINGS_ROUTE,
        use: "enclosed",
        selected: this.getActiveTab()
      }, _react.default.createElement(_UITab.default, {
        key: _constants.DOMAINS_ROUTE,
        tabId: _constants.DOMAINS_ROUTE,
        title: translateLangKey(_constants.DOMAINS_ROUTE),
        href: "/domains/" + _hubspot.default.get()
      }), _react.default.createElement(_UITab.default, {
        key: _constants.URLS_ROUTE,
        tabId: _constants.URLS_ROUTE,
        title: translateLangKey(_constants.URLS_ROUTE),
        href: "/domains/" + _hubspot.default.get() + "/url-redirects"
      }), TAB_IDS.map(this.renderTab));
    }
  }]);
  return TabsContainer;
}(_react.PureComponent);

TabsContainer.propTypes = {
  lastURLPathElement: _react.PropTypes.string.isRequired,
  pathNameFromRouting: _react.PropTypes.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    lastURLPathElement: (0, _selectors.getLastURLPathElement)(state),
    pathNameFromRouting: (0, _selectors.getPathNameFromRouting)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {})(TabsContainer);

exports.default = _default;
module.exports = exports.default;